import {
  fortuneWheelWidgetDefaultTemplate as wheel,
} from '@components/Widgets/_contentItems/FortuneWheel/template'
import { settings, styling, steps } from '@components/Widgets/Templates/_base'
import { maxWidth, type } from '@meta/widget/options'

const fortuneWheelWidgetDefaultTemplate = {
  id: '',
  type: type.FORTUNE_WHEEL,
  active: true,
  settings:
    (() => {
      const customSettings = { ...settings }
      customSettings.wheel = wheel

      return customSettings
    })(),
  styling:
    (() => {
      const customStyling = { ...styling } // Ensure we're working with a copy of the styling
      customStyling.maxWidth = maxWidth.EXTRA_LARGE

      return customStyling
    })(),
  steps: steps,
}

export default fortuneWheelWidgetDefaultTemplate
